import { HStack, Link } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { forwardRef } from 'react';
export const ShowAllLink = forwardRef(({ ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <HStack justifyContent="center">
      <Link {...props}>{t('publicProfile.showAll') || "Show all"}</Link>
    </HStack>
  );
});
